import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-master-testig-represent-json',
  templateUrl: './master-testig-represent-json.component.html',
  styleUrls: ['./master-testig-represent-json.component.scss']
})
export class MasterTestigRepresentJsonComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
